import logger from "../common/Logger";
import CoreService from "./CoreService";
import ApiService from "./ApiService";
import {defaultTenantId} from "./TenantService";

class MocksConfigService {
    constructor() {
        this.fetchFiles = this.fetchFiles.bind(this);
        this.uploadSpecification = this.uploadSpecification.bind(this);
    }

    /**
     * Fetch the mock endpoints.
     *
     * @param mockId
     * @param callback {Function}
     */
    fetchMockEndpoints(mockId = defaultTenantId, callback) {
        ApiService.makeRequest(`/api/mocks/${mockId}/endpoint`, {
            type: "GET",
            success: function (mockEndpoints) {
                callback(mockEndpoints);
            },
            error: function (result, err) {
                if (err) logger.error(err);
                CoreService.showPassiveError('Unable to fetch mock endpoints.');
            }
        });
    }

    /**
     * Fetch the list of mock files.
     *
     * @param mockId
     * @param callback {Function}
     */
    fetchFiles(mockId = defaultTenantId, callback) {
        ApiService.makeRequest(`/api/mocks/${mockId}/files`, {
            type: "GET",
            success: function (files) {
                callback(files);
            },
            error: function (result, err) {
                if (err) logger.error(err);
                CoreService.showPassiveError('Unable to list mock files.');
            }
        });
    }

    /**
     * Fetch the list of mock events.
     *
     * @param mockId
     * @param callback {Function}
     */
    fetchEvents(mockId = defaultTenantId, callback) {
        ApiService.makeRequest(`/api/mocks/${mockId}/events`, {
            type: "GET",
            success: function (events) {
                callback(events);
            },
            error: function (result, err) {
                if (err) logger.error(err);
                CoreService.showPassiveError('Unable to list mock events.');
            }
        });
    }

    /**
     * Delete the file with the given name.
     *
     * @param mockId
     * @param fileName {String}
     * @param callback {Function}
     */
    deleteFile(mockId = defaultTenantId, fileName, callback) {
        ApiService.makeRequest(`/api/mocks/${mockId}/files/${fileName}`, {
            type: "DELETE",
            success: function () {
                callback();
            },
            error: function (result, err) {
                if (err) logger.error(err);
                CoreService.showPassiveError(`Unable to delete file: ${fileName}.`);
            }
        });
    }

    /**
     * Upload the specification from the file list.
     *
     * @param mockId
     * @param files {FileList}
     * @param callback {Function}
     */
    uploadSpecification(mockId = defaultTenantId, files, callback) {
        const pending = [];

        for (const f of files) {
            // Only process YAML & JSON specifications and script files.
            if (!f.name.match('(.+)(.yaml|.yml|.json|.groovy|.js)')) {
                CoreService.showPassiveError('Sorry, you can only upload API specifications (.json, .yml or .yaml), or scripts (.groovy or .js).');
                return
            }

            pending.push(f);
        }

        if (pending.length === 0) {
            CoreService.showPassiveError('No valid files to upload.');
            return
        }

        let uploaded = 0;
        pending.forEach(f => {
            logger.debug(`Uploading file ${f.name}`);

            const data = new FormData();
            data.append(f.name, f);

            ApiService.makeRequest(`/api/mocks/${mockId}/spec`, {
                type: "POST",
                data: data,
                cache: false,
                processData: false, // Don't process the files
                contentType: false, // Set content type to false as jQuery will tell the server its a query string request
                error: function (result, err) {
                    if (err) logger.error(err);
                },
                complete: function () {
                    if (++uploaded === pending.length) {
                        logger.debug(`Uploaded ${uploaded} files`);
                        callback();
                    }
                }
            });
        });
    }

    /**
     * Force the mocks to restart.
     *
     * @param mockId
     * @param callback {Function}
     */
    pokeMocks(mockId = defaultTenantId, callback) {
        ApiService.makeRequest(`/api/mocks/${mockId}/actions/provision`, {
            type: "POST",
            cache: false,
            processData: false, // Don't process the files
            contentType: false, // Set content type to false as jQuery will tell the server its a query string request
            success: callback,
            error: function (result, err) {
                if (err) logger.error(err);
            }
        });
    }

    createMock(callback) {
        ApiService.makeRequest('/api/mocks', {
            type: 'POST',
            cache: false,
            success: function (draft) {
                console.log(`Create draft mock: ${draft.mockId}`);
                callback(draft.mockId);
            },
            error: function (result, err) {
                if (err) logger.error(err);
                CoreService.showPassiveError(`Unable to add a new mock.`);
            }
        })
    }
}

export default new MocksConfigService();



// WEBPACK FOOTER //
// ./src/modules/service/MocksConfigService.js